.menu {
  li[data-key='seoScoreGauge'] {
    > div {
      > div {
        padding: 10px 0 0 0 !important;
        border-bottom: none !important;
      }
    }
  }
}
